import { lazy } from "react";

// project imports
import MainLayout from "../layout/MainLayout";
import Loadable from "./../components/Loadable";

// dashboard routing
const Statistics = Loadable(lazy(() => import("../views/statistics")));
const Customers = Loadable(lazy(() => import("../views/customers")));
const CustomerView = Loadable(lazy(() => import("../views/customers/view")));
const CustomersManage = Loadable(
  lazy(() => import("../views/customers/manage")),
);
const CustomerManageChildAccountIndex = Loadable(
  lazy(
    () => import("../views/customers/manage/CustomerManageChildAccountIndex"),
  ),
);
const Subscriptions = Loadable(lazy(() => import("../views/subscriptions")));
const CallCustomerHistory = Loadable(
  lazy(() => import("../views/call-customer-history")),
);
// const ServicesStatus = Loadable(lazy(() => import("../views/services-status")));
const Cabinets = Loadable(lazy(() => import("../views/cabinets")));
const Reports = Loadable(lazy(() => import("../views/reports")));
const Users = Loadable(lazy(() => import("../views/users")));
const Task = Loadable(lazy(() => import("../views/task")));
const UnknownTask = Loadable(lazy(() => import("../views/unknown-task")));
const FatClearanceTask = Loadable(
  lazy(() => import("../views/fat-clearance-task")),
);
const FatClearanceTaskDetails = Loadable(
  lazy(() => import("../views/fat-clearance-task/task-details")),
);
const MaintenanceTask = Loadable(
  lazy(() => import("../views/maintenance-task")),
);
const MaintenanceTaskDetails = Loadable(
  lazy(() => import("../views/maintenance-task/task-details")),
);
const TrackingTask = Loadable(lazy(() => import("../views/tracking-task")));
const TrackingTaskDetails = Loadable(
  lazy(() => import("../views/maintenance-task/task-details")),
);

const SubscriptionRequestTask = Loadable(
  lazy(() => import("../views/subscription-request-task")),
);
const TicketQuality = Loadable(lazy(() => import("../views/ticket-quality")));
const TicketQualityDetails = Loadable(
  lazy(() => import("../views/ticket-quality/ticket-details")),
);
// const MaintenanceTaskReplies = Loadable(
//   lazy(() => import("../views/task/task-replies/index"))
// );

// const ExpiryCustomers = Loadable(
//   lazy(() => import("../views/expiry-customers"))
// );
const TaskDetails = Loadable(lazy(() => import("../views/task/task-details")));
//roles & permissions
const RolesPermissions = Loadable(
  lazy(() => import("../views/roles-permissions")),
);
//clients
const Clients = Loadable(lazy(() => import("../views/clients")));
const Transactions = Loadable(lazy(() => import("../views/transactions")));
// const Tickets = Loadable(lazy(() => import("../views/tickets")));
const SubscriptionService = Loadable(
  lazy(() => import("../views/subscription-service")),
);
const Variables = Loadable(lazy(() => import("../views/variables")));
const Home = Loadable(lazy(() => import("../views/home")));

const Offers = Loadable(lazy(() => import("../views/offers")));
const SubscriptionsPrice = Loadable(
  lazy(() => import("../views/subscriptions-price")),
);
const Announcements = Loadable(lazy(() => import("../views/announcement")));
// const QA = Loadable(lazy(() => import("../views/qa")));
const UserWallet = Loadable(lazy(() => import("../views/user-wallet")));
const WalletTransaction = Loadable(
  lazy(() => import("../views/wallet-transaction")),
);

const FatMaintenance = Loadable(lazy(() => import("../views/fat-Maintenance")));
const Apk = Loadable(lazy(() => import("../views/apk")));
const FtthPanel = Loadable(lazy(() => import("../views/ftth-panel")));

const Items = Loadable(lazy(() => import("../views/warehouse/items")));
const Warehouse = Loadable(lazy(() => import("../views/warehouse/warehouse")));
const MyItems = Loadable(lazy(() => import("../views/warehouse/my-items")));
const OrderHistory = Loadable(
  lazy(() => import("../views/warehouse/order-history")),
);
const Orders = Loadable(
  lazy(() => import("../views/warehouse/orders")),
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/my-items",
      children: [
        {
          path: "/my-items",
          element: <MyItems />,
        },
      ],
    },
    {
      path: "/order-history",
      children: [
        {
          path: "/order-history",
          element: <OrderHistory />,
        },
      ],
    },
    {
      path: "/wharehouse-items",
      children: [
        {
          path: "/wharehouse-items",
          element: <Items />,
        },
      ],
    },
    {
      path: "/wharehouse",
      children: [
        {
          path: "/wharehouse",
          element: <Warehouse />,
        },
      ],
    },
    {
      path: "/orders",
      children: [
        {
          path: "/orders",
          element: <Orders />,
        },
      ],
    },
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/apk",
      element: <Apk />,
    },
    {
      path: "/user-wallet",
      element: <UserWallet />,
    },
    {
      path: "/wallet-transaction",
      element: <WalletTransaction />,
    },
    {
      path: "/statistics",
      element: <Statistics />,
    },
    {
      path: "/fat-maintenance",
      element: <FatMaintenance />,
    },
    {
      path: "/announcements",
      children: [
        {
          path: "/announcements",
          element: <Announcements />,
          index: true,
        },
      ],
    },
    {
      path: "/variables",
      children: [
        {
          path: "/variables",
          element: <Variables />,
          index: true,
        },
      ],
    },
    // {
    //   path: "/qa",
    //   children: [
    //     {
    //       path: "/qa",
    //       element: <QA />,
    //       index: true,
    //     },
    //   ],
    // },
    {
      path: "/offers",
      element: <Offers />,
    },
    {
      path: "/ftth-panels",
      element: <FtthPanel />,
    },
    // {
    //   path: "/offers",
    //   element: <Offers />,
    // },
    {
      path: "/subscriptions-price",
      element: <SubscriptionsPrice />,
    },
    {
      path: "/subscription-service",
      children: [
        {
          path: "/subscription-service",
          element: <SubscriptionService />,
          index: true,
        },
      ],
    },
    {
      path: "/transactions",
      children: [
        {
          path: "/transactions",
          element: <Transactions />,
          index: true,
        },
      ],
    },
    {
      path: "/clients",
      children: [
        {
          path: "/clients",
          element: <Clients />,
          index: true,
        },
      ],
    },
    {
      path: "/call-customer-history",
      children: [
        {
          path: "/call-customer-history",
          element: <CallCustomerHistory />,
          index: true,
        },
      ],
    },
    {
      path: "/task",
      children: [
        {
          path: "/task",
          element: <Task />,
          index: true,
        },
        {
          path: "/task/:id",
          element: <TaskDetails />,
        },
      ],
    },
    {
      path: "/unknown-task",
      children: [
        {
          path: "/unknown-task",
          element: <UnknownTask />,
          index: true,
        },
      ],
    },
    {
      path: "/tracking-task",
      children: [
        {
          path: "/tracking-task",
          element: <TrackingTask />,
          index: true,
        },
        {
          path: "/tracking-task/:id",
          element: <TrackingTaskDetails />,
        },
      ],
    },
    {
      path: "/maintenance-task",
      children: [
        {
          path: "/maintenance-task",
          element: <MaintenanceTask />,
          index: true,
        },
        {
          path: "/maintenance-task/:id",
          element: <MaintenanceTaskDetails />,
        },
      ],
    },
    {
      path: "/ticket-quality",
      children: [
        {
          path: "/ticket-quality",
          element: <TicketQuality />,
          index: true,
        },
        {
          path: "/ticket-quality/:id",
          element: <TicketQualityDetails />,
        },
      ],
    },
    {
      path: "/subscription-request-task",
      children: [
        {
          path: "/subscription-request-task",
          element: <SubscriptionRequestTask />,
          index: true,
        },
        {
          path: "/subscription-request-task/:id",
          element: <TaskDetails />,
        },
      ],
    },
    {
      path: "/fat-clearance-task",
      children: [
        {
          path: "/fat-clearance-task",
          element: <FatClearanceTask />,
          index: true,
        },
        {
          path: "/fat-clearance-task/:id",
          element: <FatClearanceTaskDetails />,
        },
      ],
    },
    {
      path: "/customers",
      children: [
        {
          path: "/customers",
          element: <Customers />,
          index: true,
        },
        {
          path: "/customers/add",
          element: <CustomersManage />,
        },
        {
          path: "/customers/add/child/:parent_customer_id",
          element: <CustomerManageChildAccountIndex />,
        },
        {
          path: "/customers/add-with-task/:task_id",
          element: <CustomersManage />,
        },
        {
          path: "/customers/edit/:id",
          element: <CustomersManage />,
        },
        {
          path: "/customers/view/:id",
          element: <CustomerView />,
        },
      ],
    },
    {
      path: "/users",
      children: [
        {
          path: "/users",
          element: <Users />,
          index: true,
        },
      ],
    },
    // {
    //   path: "/tickets",
    //   children: [
    //     {
    //       path: "/tickets",
    //       element: <Tickets />,
    //       index: true,
    //     },
    //   ],
    // },
    {
      path: "/cabinets",
      children: [
        {
          path: "/cabinets",
          element: <Cabinets />,
          index: true,
        },
      ],
    },
    {
      path: "/subscriptions",
      children: [
        {
          path: "/subscriptions",
          element: <Subscriptions />,
          index: true,
        },
      ],
    },
    {
      path: "/reports",
      children: [
        {
          path: "/reports",
          element: <Reports />,
        },
      ],
    },
    {
      path: "/roles-permissions",
      children: [
        {
          index: true,
          element: <RolesPermissions />,
        },
      ],
    },
  ],
};

export default MainRoutes;
